/**
 * Product List Marquee & Carousel Arrows Integration
 * Moves carousel navigation arrows into the marquee header area
 */

document.addEventListener('DOMContentLoaded', function() {
  // Initialize marquee animation
  initMarqueeAnimation();
  
  // Initialize carousel arrows
  initCarouselArrows();
});

function initMarqueeAnimation() {
  const marqueeContainers = document.querySelectorAll('.product-list__marquee-background');
  
  marqueeContainers.forEach(container => {
    const marqueeItems = container.querySelector('.marquee__repeated-items');
    if (!marqueeItems) return;
    
    // Clone the items to create infinite scroll effect
    const clone = marqueeItems.cloneNode(true);
    const content = container.querySelector('.marquee__content');
    if (content) {
      content.appendChild(clone);
    }
  });
}

function initCarouselArrows() {
  const productListSections = document.querySelectorAll('.product-list--arrows-header');
  
  productListSections.forEach(section => {
    const arrowsPlaceholder = section.querySelector('.product-list__carousel-arrows');
    
    if (!arrowsPlaceholder) {
      console.log('No arrows placeholder found in section');
      return;
    }
    
    console.log('Arrows placeholder found:', arrowsPlaceholder);
    
    // Function to move arrows to header
    const moveArrowsToHeader = () => {
      // Look for slideshow component and its arrows
      const slideshow = section.querySelector('slideshow-component');
      
      if (!slideshow) {
        console.log('No slideshow component found yet');
        return;
      }
      
      const slideshowArrows = slideshow.querySelector('slideshow-arrows');
      
      if (!slideshowArrows) {
        console.log('No slideshow arrows found in slideshow component');
        return;
      }
      
      if (arrowsPlaceholder.children.length === 0) {
        console.log('Moving arrows to header...');
        
        // Clone the arrows (don't move original to avoid breaking slideshow)
        const arrowsClone = slideshowArrows.cloneNode(true);
        arrowsPlaceholder.appendChild(arrowsClone);
        
        // Add event listeners to cloned buttons to control original slideshow
        if (arrowsClone instanceof HTMLElement) {
          const clonedButtons = arrowsClone.querySelectorAll('button');
          const originalButtons = slideshowArrows.querySelectorAll('button');
          
          clonedButtons.forEach((btn, idx) => {
            btn.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();
              if (originalButtons[idx]) {
                originalButtons[idx].click();
              }
            });
          });
        }
        
        // Hide original arrows
        if (slideshowArrows instanceof HTMLElement) {
          slideshowArrows.style.display = 'none';
        }
        
        // Show cloned arrows in header
        if (arrowsPlaceholder instanceof HTMLElement) {
          arrowsPlaceholder.style.display = 'flex';
          arrowsPlaceholder.style.visibility = 'visible';
        }
        
        if (arrowsClone instanceof HTMLElement) {
          arrowsClone.style.display = 'flex';
          arrowsClone.style.visibility = 'visible';
          arrowsClone.style.opacity = '1';
        }
        
        console.log('✓ Arrows successfully moved to header');
      }
    };
    
    // Try multiple times as carousel loads asynchronously
    setTimeout(moveArrowsToHeader, 100);
    setTimeout(moveArrowsToHeader, 300);
    setTimeout(moveArrowsToHeader, 600);
    setTimeout(moveArrowsToHeader, 1000);
    setTimeout(moveArrowsToHeader, 2000);
    
    // Watch for slideshow component to be added
    const observer = new MutationObserver(() => {
      moveArrowsToHeader();
    });
    
    observer.observe(section, {
      childList: true,
      subtree: true
    });
  });
}
